module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_vm._l((_vm.data), function(maxages, minage) {
    return (_vm.SITE_CONFIG.modules_open.school.open) ? _c('div', _vm._l((maxages), function(schools, maxage) {
      return _c('div', {
        staticClass: "list"
      }, [_c('div', {
        staticClass: "list-header"
      }, [(_vm.isPrivate(schools) && (_vm.isSnowboard(schools) || _vm.$route.query.type === 'snowboard')) ? _c('span', [_vm._v(_vm._s((_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') ? _vm.$t('skischool.types-singular.private-snowboard') : _vm.$t('skischool.types.private-snowboard')))]) : (_vm.isPrivate(schools) || _vm.$route.query.type === 'private') ? _c('span', [_vm._v(_vm._s((_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') ? _vm.$t('skischool.types-singular.private') : _vm.$t('skischool.types.private')))]) : (maxage < 70) ? _c('span', [_vm._v(_vm._s(minage !== maxage ? minage + '-' + maxage : minage) + " " + _vm._s(_vm.$t('general.years')))]) : (maxage >= 70 && minage <= 0) ? _c('span', [(_vm.$route.query.type === 'group') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.types.group')))]) : _vm._e(), _vm._v(" "), (_vm.$route.query.type === 'snowboard') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.types.snowboard')))]) : _vm._e()]) : (maxage >= 70 && minage > 0) ? _c('span', [_vm._v(_vm._s(minage) + "+ " + _vm._s(_vm.$t('general.years')))]) : _vm._e()]), _vm._v(" "), _c('transition-group', {
        staticClass: "animate-list separator",
        attrs: {
          "name": "animate-list",
          "tag": "ul"
        }
      }, _vm._l((schools), function(level) {
        return _c('div', {
          key: (level.info.level + '-' + minage + '-' + maxage),
          staticClass: "animate-list-item area-wrapper"
        }, [_c('SkiSchoolListPool', {
          attrs: {
            "level": level
          }
        })], 1)
      }), 0)], 1)
    }), 0) : _vm._e()
  }), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.school.open) ? _c('div', {
    staticClass: "no-results"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.school.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.school.open && (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget')) ? _c('div', [(!_vm.count) ? _c('div', {
    staticClass: "no-results"
  }, [_c('b', [_vm._v("Inga sökresultat")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('p', [_vm._v("För alla vuxna erbjuder vi endast privatlektioner.")]) : _vm._e()]) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Hittar du inte det du söker, skicka in en skidskoleförfrågan via "), _c('a', {
    attrs: {
      "href": "/gastservice/kontakta-oss/"
    }
  }, [_vm._v("vårt formulär")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7210695b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/SkiSchool/SkiSchoolList.vue
// module id = 994
// module chunks = 0